<template>
    <div>
      <img src="../../../assets/1st/Articles/Article_6/contant_1.jpeg"/>
    </div>
</template>

<script>
    export default {
        name: "Article6"
    }
</script>

<style scoped>
  img{
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/1st/Articles/Article6.vue